import {SmallLoader} from '@kit';

import React, {useMemo} from 'react';

import {Link} from '../../../lib/routes';
import {groupArrayBy, getApolloError, cls, uppercaseFirstLetter} from '../../../components/utils';
import {useSpellsClassQuery} from '../../../generated/types';
import {spellSchoolToString} from '../../../components/enums';

import pageCss from '../../../components/common.module.css';
import markdownCss from '../../../components/utils/md/markdown.module.css';
import markdownPluginsCss from '../../../components/utils/md/plugins/commone.module.css';

type Props = {
	classId: string;
};

export const ClassSpells: React.FC<Props> = ({classId}) => {
	const {data, loading, error} = useSpellsClassQuery({variables: {id: classId}, ssr: true});
	const spellsByLevels = useMemo(() => {
		if (data?.class?.spells) return groupArrayBy(data.class?.spells, (spell) => spell.level);
		return {};
	}, [data?.class?.spells]);

	const levels = useMemo(() => {
		return Object.keys(spellsByLevels).sort();
	}, [spellsByLevels]);
	return (
		<>
			{loading && (
				<div className={pageCss.fullSizeBlock}>
					<SmallLoader />
				</div>
			)}
			{error && <div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>}
			{data?.class && (
				<p>
					В этом разделе представлен список заклинаний{' '}
					{uppercaseFirstLetter(data?.class.cases.genitive || '')}. Заклинания упорядочены по кругам
					и расположены в алфавитном порядке, при этом для каждого заклинания указана его школа магии. Буквы
					в столбце «Особое» означают следующее: К — заклинание требует Концентрации, Р — заклинание можно
					сотворить как Ритуал, М — заклинание требует определённого Материального компонента.
				</p>
			)}
			<ul>
				{levels.map((level) => (
					<li key={level}>
						<h2>{level === '0' ? 'Фокусы' : `${level}-й круг`}</h2>
						<div className={markdownCss.tableScroll}>
							<table className={markdownCss.table}>
								<colgroup>
									<col style={{width: '60%'}} />
									<col style={{width: '20%'}} />
									<col style={{width: '20%'}} />
								</colgroup>
								<thead>
									<tr>
										<th scope="col">Заклинание</th>
										<th scope="col">Школа</th>
										<th scope="col" className={markdownCss.alignCenter}>
											Особое
										</th>
									</tr>
								</thead>
								<tbody>
									{spellsByLevels[level].map((spell) => {
										const params = [];
										if (spell.ritual) params.push('Р');
										if (spell.duration.at(0)?.concentration) params.push('К');
										if (spell.components.m?.coast || spell.components.m?.consume) params.push('М');

										return (
											<tr key={spell.id}>
												<td>
													<Link
														route={'spell'}
														params={{id: spell.id}}
														className={markdownPluginsCss.violetLink}
													>
														<i>{spell.title}</i>
													</Link>
												</td>
												<td>{spellSchoolToString(spell.school)}</td>
												<td className={markdownCss.alignCenter}>{params.join(', ')}</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</li>
				))}
			</ul>
		</>
	);
};
